import { API_PATH } from '../../config';

const DEFAULT = { population_count: -1 };

const getNegative = () => -1;
// eslint-disable-next-line camelcase
const pickPopulation = ({ population_count }) => population_count;
// eslint-disable-next-line no-mixed-operators
const toJson = (result) => result && result.json && result.json() || DEFAULT;

export default (
    coordinate,
    radius,
    altitude,
) => fetch(`${API_PATH}/population/radius`, {
  method: 'POST',
  body: JSON.stringify({
    altitude,
    coordinate: [coordinate.lng, coordinate.lat],
    radius,
  }),
  headers: {
    'Content-Type': 'application/json',
  },
})
    .then(toJson)
    .then(pickPopulation)
    .catch(getNegative);
